import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import { SHARED_ROUTES, ADMIN_ROUTES } from "./config/routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ChakraBaseProvider } from "@chakra-ui/react";
import MainNavigation from "./components/Navigation/MainNavigation";
import Home from "./Users/pages/Home";
import Login from "./Users/pages/Login";
import Signup from "./Users/pages/Signup";
import { AdminWeekView }  from "./Students/pages/AdminWeekView";
import Booking from "./Bookings/pages/Booking";
import Footer from "./components/Navigation/Footer";
import Edit from "./Students/pages/EditStudent";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import AuthListener from "./AuthListener";
import { artyTheme } from "./chakra-ui.config";

function App() {
  return (
    <ChakraBaseProvider theme={artyTheme}>
      <Authenticator.Provider>
        <Router>
          <MainNavigation />
          <AuthListener />
          <main>
            <Routes>
              <Route path={SHARED_ROUTES.home} element={<Home />} exact />
              <Route path={SHARED_ROUTES.createStudent} element={<Booking />} exact />
              <Route path={SHARED_ROUTES.editStudent} element={<Edit />} exact />
              <Route path={ADMIN_ROUTES.weekView} element={<AdminWeekView />} exact />
              <Route path="/signup" element={<Signup />} exact />
              <Route path="/" element={<Login />} exact />
            </Routes>
          </main>
        </Router>
        <Footer />
        <ToastContainer />
      </Authenticator.Provider>
    </ChakraBaseProvider>
  );
}

export default App;
